import React, { useEffect, useRef } from 'react'
import styles from "../css/ColorMenu.module.css"
import { colors } from '../../../data/colorsDict'
import useCoords from '../../../hooks/useCoords'

const ColorMenu = ({selectedColor,selectColor,closeMenu}) => {
    const menu = useRef(null)
    useCoords(menu,"color-menu")

    useEffect(()=>{
        const handleClick = (e) => {
            if (!menu.current?.contains(e.target) && !menu.current?.previousElementSibling?.contains(e.target)){
                closeMenu()
            }
        }
        window.addEventListener("mousedown",handleClick)

        return () => {
            window.removeEventListener("mousedown",handleClick)
        }
    },[closeMenu])

    const setColor = (color) => {
        selectColor(color.name)
        closeMenu()
    }

  return (
    <div data-testid = "color-menu" className = {styles.menu} ref = {menu}>
        {colors.map((color,index)=>(
            <div data-testid = {`color-${color.name}`} className = {`${styles.colorWrapper} ${color.name === selectedColor ? styles.selected : ""}`} style = {{ borderColor: color.code }} key = {index} onClick = {()=>setColor(color)}>
                <div className = {styles.colorBox} style = {{ backgroundColor: color.code }}></div>
            </div>
        ))}
    </div>
  )
}

export default ColorMenu